// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3F5cS","selects":"Documents_selects__2elsr"};